// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__wzWzB","bigColWidth":"Table_bigColWidth__3TF8r","biggerColWidth":"Table_biggerColWidth__3e7aJ","row":"Table_row__3V3Qo","col":"Table_col__24ftZ"};